<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
      </template>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe p-r">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >评标基准价筛选</el-button
              >
            </div>
            <div class="tipp">
              注：若确认投标人报价不参与评标基准价计算，则默认该投标人的投标报价文件初步评审不通过
            </div>
          </div>
          <el-table
            v-if="subPackageFlag"
            :data="tableData"
            border
            :span-method="objectSpanMethodReport"
          >
            <el-table-column
              v-for="(item, index) in confirmCheckColumns"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>
                  <span>{{ item.label }}</span>
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-if="
                    item.type === 'select' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  :disabled="scope.row.disabled === '0'"
                  v-model.trim="scope.row[item.prop]"
                  @change="changeLostFlag(scope.row, scope.$index)"
                >
                  <el-option value="1" label="是"></el-option>
                  <el-option value="0" label="否"></el-option>
                </el-select>
                <template
                  v-else-if="
                    item.type === 'select1' &&
                      scope.row.isJoinGuidePrice == '0' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                >
                  <el-select
                    v-if="scope.row.disabled === '0'"
                    :disabled="scope.row.disabled === '0'"
                    v-model.trim="scope.row[item.prop]"
                  >
                    <el-option value="1" label="超出投标总价限价"></el-option>
                    <el-option
                      value="2"
                      label="未通过商务及技术文件评审"
                    ></el-option>
                    <el-option value="3" label="单项超限价"></el-option>
                    <el-option
                      value="4"
                      label="未在投标函上填写投标总价"
                    ></el-option>
                    <el-option value="5" label="其他情况"></el-option>
                  </el-select>

                  <el-select v-else v-model.trim="scope.row[item.prop]">
                    <el-option value="3" label="单项超限价"></el-option>
                    <el-option
                      value="4"
                      label="未在投标函上填写投标总价"
                    ></el-option>
                    <el-option value="5" label="其他情况"></el-option>
                  </el-select>
                </template>

                <span v-else-if="item.type === 'select'">
                  {{ scope.row[item.prop + "Str"] }}
                </span>
                <span v-else-if="item.type === 'select1'">
                  {{ scope.row[item.prop + "Str"] }}
                </span>
                <el-input
                  v-else-if="
                    item.type === 'input' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  :disabled="scope.row.disabled === '0'"
                  v-model.trim="scope.row[item.prop]"
                  maxlength="1000"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  placeholder="请输入"
                />
                <el-button
                  v-else-if="item.type == 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                >
                  查看
                </el-button>
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="tableData" border v-else>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              v-for="(item, index) in confirmCheckColumns2"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>
                  <span>{{ item.label }}</span>
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-if="
                    item.type === 'select' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  :disabled="scope.row.disabled === '0'"
                  v-model.trim="scope.row[item.prop]"
                  @change="changeLostFlag(scope.row, scope.$index)"
                >
                  <el-option value="1" label="是"></el-option>
                  <el-option value="0" label="否"></el-option>
                </el-select>
                <template
                  v-else-if="
                    item.type === 'select1' &&
                      scope.row.isJoinGuidePrice == '0' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                >
                  <el-select
                    v-if="scope.row.disabled === '0'"
                    :disabled="scope.row.disabled === '0'"
                    v-model.trim="scope.row[item.prop]"
                  >
                    <el-option value="1" label="超出投标总价限价"></el-option>
                    <el-option
                      value="2"
                      label="未通过商务及技术文件评审"
                    ></el-option>
                    <el-option value="3" label="单项超限价"></el-option>
                    <el-option
                      value="4"
                      label="未在投标函上填写投标总价"
                    ></el-option>
                    <el-option value="5" label="其他情况"></el-option>
                  </el-select>

                  <el-select v-else v-model.trim="scope.row[item.prop]">
                    <el-option value="3" label="单项超限价"></el-option>
                    <el-option
                      value="4"
                      label="未在投标函上填写投标总价"
                    ></el-option>
                    <el-option value="5" label="其他情况"></el-option>
                  </el-select>
                </template>
                <span v-else-if="item.type === 'select'">
                  {{ scope.row[item.prop + "Str"] }}
                </span>
                <span v-else-if="item.type === 'select1'">
                  {{ scope.row[item.prop + "Str"] }}
                </span>
                <el-input
                  v-else-if="
                    item.type === 'input' &&
                      (exeStatus === '0' || (exeStatus === '2' && isEdit)) &&
                      expertRole === '1'
                  "
                  :disabled="scope.row.disabled === '0'"
                  v-model.trim="scope.row[item.prop]"
                  maxlength="1000"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  placeholder="请输入"
                />
                <el-button
                  v-else-if="item.type == 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                >
                  查看
                </el-button>
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="operate">
        <!--      组长按钮-->
        <template v-if="expertRole === '1'">
          <template>
            <!-- <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-save"
              @click="dealSupComCheckSave('1')"
              v-if="exeStatus === '0' || (exeStatus === '2' && isEdit)"
              >保存</el-button
            >
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-edit"
              v-if="exeStatus === '2' && !isEdit"
              @click="edit"
              >编辑</el-button
            >
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-save"
              @click="dealSupComCheckSave('2')"
              v-if="billStatus !== '1'"
              >提交确认</el-button
            > -->
            <el-button
              type="text"
              v-preventReClick
              icon="icon-ccui-agree"
              @click="refCheckEffect"
              v-if="exeStatus === '0'"
              >生效</el-button
            >
            <el-button
              type="text"
              icon="icon-ccui-sharing-o"
              @click="init"
              v-if="!isEdit"
              >刷新</el-button
            >
          </template>
        </template>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        title="商务及技术信息详情"
        width="1200px"
        v-if="dialogVisible"
      >
        <supplierBidDetails
          :supQuoteId="formData.supQuoteId"
          :supPackQuoteId="formData.supPackQuoteId"
          :supCode="formData.supCode"
          :packId="formData.packId"
        ></supplierBidDetails>
        <div slot="footer"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetailsNew.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryEvaScreenPackList,
  scpDealSupComCheckSaveApi,
  scpQueryPurchaseSchemeDetailApi,
  dealEvaScreenPack,
  // checkSubconControlAndBlack,
  scpQryBidEvaProcessStatusApi,
  scpListPurchaseSchemePackageApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import bidEvaProcessStatus from "@/app/subSourcingFlow/mixins/getBidEvaProcessStatus.js";
import { exportJsonToExcel } from "@/basa/utils/Export2Excel";

export default {
  name: "bidReportEdit",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  /**
   * billStatus   exeStatus(操作)       按钮
   0检查中  0未检查（第一次）		保存  提交确认 刷新
   0检查中  2检查中（保存）		    编辑  提交确认 生效  刷新
   2确认中	2检查中（提交确认）	    编辑  提交确认 生效  刷新
   1检查完成	1检查完成（生效）		刷新
   **/
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      BigNumber: BigNumber,
      purchaseUnitId: "",
      breadcrumbData: {
        titname: "初步评审编制",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "editorial"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "2"
          ? "confirmation"
          : "checkCompleted", // 确认中（2）：confirmation 检查中（0）：editorial 检查完成（1）：
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      exeStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .exeStatus,
      // exeStatus: "0",
      tableData: [],
      expertConfirmtableData: [],
      dialogVisible: false,
      supComCheckConfirm: {
        confirmOpinion: ""
      },
      expertRole: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .expertRole, // 专家角色 : 1-组长 0-组员
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件id
      },
      confirmCheckColumns: [
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "packName",
          label: "包件名称",
          width: 140
        },
        {
          prop: "supName",
          label: "分包商",
          minWidth: 280
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        // {
        //   prop: "supCode",
        //   label: "商务及技术信息",
        //   type: "link",
        //   width: 150
        // },
        {
          prop: "isJoinGuidePrice",
          label: "是否参与基准价计算",
          width: 200,
          type: "select",
          required: true
        },
        {
          prop: "notJoinReason",
          label: "不参与原因",
          type: "select1",
          "min-width": 200,
          required: true
        },
        {
          prop: "reason",
          label: "备注",
          type: "input",
          "min-width": 200
        }
      ],
      confirmCheckColumns2: [
        {
          prop: "supName",
          label: "分包商",
          minWidth: 280
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 260,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 260,
          align: "right",
          money: true
        },
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 260,
          align: "right",
          money: true
        },
        // {
        //   prop: "supCode",
        //   label: "商务及技术信息",
        //   type: "link",
        //   width: 150
        // },
        {
          prop: "isJoinGuidePrice",
          label: "是否参与基准价计算",
          width: 200,
          type: "select"
        },
        {
          prop: "notJoinReason",
          label: "不参与原因",
          type: "select1",
          "min-width": 200,
          required: true
        },
        {
          prop: "reason",
          label: "备注",
          type: "input",
          "min-width": 200,
          required: true
        }
      ],
      expertColumns: [
        {
          prop: "round",
          label: "确认轮数",
          width: 80
        },
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "confirmUserName",
          label: "专家姓名",
          width: 120
        },
        {
          prop: "confirmResultStr",
          label: "确认结果",
          width: 120
        },
        {
          prop: "confirmOpinion",
          label: "确认意见"
        },
        {
          prop: "confirmTime",
          label: "确认日期",
          width: 170
        },
        {
          prop: "confirmStatusStr",
          label: "确认状态",
          width: 80
        }
      ],
      exportExcelData: [],
      labelShow: false,
      subPackageFlag: false, //true分包，false不分包
      purchaseType: "",
      isEdit: false
    };
  },
  created() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
  },
  mounted() {
    this.getData();
    this.getPutId();
    this.getPackageFlag();
    this.labelShow = true;
  },
  watch: {
    purchaseType: {
      handler(newVal) {
        if (
          newVal == "1" ||
          newVal == "2" ||
          newVal == "4" ||
          newVal == "7" ||
          newVal == "8"
        ) {
          let bidEvaProcessStatus = JSON.parse(
            sessionStorage.getItem("bidEvaProcessStatus")
          );
          switch (bidEvaProcessStatus.billStatus) {
            case "0":
              this.breadcrumbData.status = "评审中";
              break;
            case "1":
              this.breadcrumbData.status = "评审完成";
              break;
            case "2":
              this.breadcrumbData.status = "评审确认中";
              break;
            default:
              break;
          }
          this.confirmCheckColumns.forEach(item => {
            if (item.prop == "supCode") {
              item.label = "响应文件";
            }
          });
          this.confirmCheckColumns2.forEach(item => {
            if (item.prop == "supCode") {
              item.label = "响应文件";
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    getPutId() {
      scpQueryPurchaseSchemeDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.purchaseUnitId = res.data.data.purchaseUnitId;
      });
    },
    getPackageFlag() {
      let expertSourceData = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      );

      if (
        expertSourceData.purchaseType == "50" ||
        expertSourceData.purchaseType == "53"
      ) {
        this.confirmCheckColumns.splice(3, 1);
        this.confirmCheckColumns2.splice(1, 1);
      }
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    init() {
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        this.$set(this, "labelShow", false);
        this.billStatus = res.data.data.billStatus;
        this.$set(
          this,
          "labelType",
          res.data.data.billStatus === "0"
            ? "editorial"
            : res.data.data.billStatus === "2"
            ? "confirmation"
            : "checkCompleted"
        );
        // this.labelType =
        //   this.billStatus === "0"
        //     ? "editorial"
        //     : this.billStatus === "2"
        //     ? "confirmation"
        //     : "checkCompleted";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        console.log(res.data.data, "res.data.data");
        this.isEdit = false;
        let bidEvaProcessStatus = JSON.parse(
          sessionStorage.getItem("bidEvaProcessStatus")
        );
        if (
          this.purchaseType == "1" ||
          this.purchaseType == "4" ||
          this.purchaseType == "7" ||
          this.purchaseType == "8"
        ) {
          let bidEvaProcessStatus = JSON.parse(
            sessionStorage.getItem("bidEvaProcessStatus")
          );
          switch (bidEvaProcessStatus.billStatus) {
            case "0":
              this.breadcrumbData.status = "评审中";
              break;
            case "1":
              this.breadcrumbData.status = "评审完成";
              break;
            case "2":
              this.breadcrumbData.status = "评审确认中";
              break;
            default:
              break;
          }
        }
        this.$set(
          this.breadcrumbData,
          "status",
          bidEvaProcessStatus.billStatusName
        );
        this.$set(this, "labelShow", true);
        this.getData();
        this.reload();
      });
    },
    edit() {
      this.isEdit = true;
    },
    getData() {
      // 分包商初步评审结果列表
      qryEvaScreenPackList({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        systemFlag: 0,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.evaPurStep,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        if (res.data.code === "0") {
          this.exportExcelData = res.data.data.sscEvaExtractPackResultBOS;
          let data = [];
          let devspan = 0;
          // 是包件id进行排序
          res.data.data.sscEvaExtractPackResultBOS.sort(function(a, b) {
            if (a.packId > b.packId) {
              return 1;
            } else if (a.packId < b.packId) {
              return -1;
            } else {
              return 0;
            }
          });
          if (
            res.data.data.sscEvaExtractPackResultBOS &&
            res.data.data.sscEvaExtractPackResultBOS.length > 0
          ) {
            res.data.data.sscEvaExtractPackResultBOS.forEach((item, index) => {
              if (item.packId == 0) {
                this.confirmCheckColumns.splice(1, 1);
              }
              if (index > 0) {
                devspan +=
                  res.data.data.sscEvaExtractPackResultBOS[index - 1]
                    .sscEvaExtractPackBOS.length;
              }
              if (
                item.sscEvaExtractPackBOS &&
                item.sscEvaExtractPackBOS.length > 0
              ) {
                item.sscEvaExtractPackBOS.forEach((itemtow, indextow) => {
                  let obj = {
                    id: index + 1,
                    packName:
                      item.packStatus == "5" || item.packStatus == "2"
                        ? item.packName + "(已流标)"
                        : item.packName, // 是否流标packStatus 1正常2流标（评标前流标）5流标（评标后流标）
                    packId: item.packId,
                    supCode: itemtow.supCode,
                    supName: itemtow.supName,
                    supQuoteId: itemtow.supQuoteId,
                    priceAmount: itemtow.priceAmount,
                    noTaxPriceAmount: itemtow.noTaxPriceAmount,
                    taxAmount: itemtow.taxAmount,
                    industryTypeName: itemtow.industryTypeName,
                    companyTypeName: itemtow.companyTypeName,
                    isJoinGuidePrice:
                      itemtow.isJoinGuidePrice === null ||
                      itemtow.isJoinGuidePrice === ""
                        ? "1"
                        : String(itemtow.isJoinGuidePrice),
                    isJoinGuidePriceStr: itemtow.isJoinGuidePriceStr,
                    supJoinId: itemtow.supJoinId,
                    supPackQuoteId: itemtow.supPackQuoteId,
                    notJoinReason: itemtow.notJoinReason,
                    notJoinReasonStr: itemtow.notJoinReasonStr || "",
                    round: itemtow.round,
                    disabled: itemtow.disabled,
                    reason: itemtow.reason,
                    rowspan: item.sscEvaExtractPackBOS.length,
                    devspan: devspan
                  };
                  data.push(obj);
                });
              }
            });
            this.tableData = data;
          }
        }
      });
    },
    //初步评审结果
    objectSpanMethodReport({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.formData.packId = row.packId;
      this.dialogVisible = true;
    },
    changeLostFlag(row, index) {
      // if (row.isJoinGuidePrice === "1") {
      //   // 否 notJoinReason
      //   row.notJoinReason = "是";
      // } else {
      //   // 是
      //   row.notJoinReason = "否";
      // }
    },
    dealSupComCheckSave(type) {
      console.log("符合性编制检查");
      // 不参与原因不能为空
      let flag = true;
      this.tableData.forEach(item => {
        if (!item.notJoinReason) {
          flag = false;
        }
      });
      let packIdArr = [];
      this.tableData.forEach(item => {
        if (packIdArr.every(packItem => packItem.packId !== item.packId)) {
          packIdArr.push(item);
        }
      });
      let sscPackSupComCheckBOS = [];
      packIdArr.forEach(item => {
        let sscPackSupComCheckBO = {};
        let sscEvaExtractPackBOS = [];
        sscPackSupComCheckBO.packId = item.packId;
        sscPackSupComCheckBO.packName = item.packName;
        this.tableData.forEach(tableItem => {
          if (item.packId === tableItem.packId) {
            let sscSupComPriceBO = {};
            sscSupComPriceBO.supCode = tableItem.supCode;
            sscSupComPriceBO.supName = tableItem.supName;
            sscSupComPriceBO.priceAmount = tableItem.priceAmount;
            sscSupComPriceBO.taxAmount = tableItem.taxAmount;
            sscSupComPriceBO.noTaxPriceAmount = tableItem.noTaxPriceAmount;
            sscSupComPriceBO.isJoinGuidePrice = tableItem.isJoinGuidePrice;
            sscSupComPriceBO.isJoinGuidePriceStr =
              tableItem.isJoinGuidePrice === "1" ? "是" : "否";
            sscSupComPriceBO.notJoinReason = tableItem.notJoinReason;
            sscSupComPriceBO.round = tableItem.round;
            sscSupComPriceBO.supJoinId = tableItem.supJoinId;
            sscSupComPriceBO.supQuoteId = tableItem.supQuoteId;
            sscSupComPriceBO.supPackQuoteId = tableItem.supPackQuoteId;
            sscEvaExtractPackBOS.push(sscSupComPriceBO);
          }
        });
        sscPackSupComCheckBO.sscEvaExtractPackBOS = sscEvaExtractPackBOS;
        sscPackSupComCheckBOS.push(sscPackSupComCheckBO);
      });
      console.log("sscPackSupComCheckBOS", sscPackSupComCheckBOS);
      console.log("tableData", this.tableData);
      if (flag) {
        scpDealSupComCheckSaveApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          operType: type,
          purStep: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          sscPackSupComCheckBOS: sscPackSupComCheckBOS
        }).then(res => {
          if (res.data.code == "0") {
            this.init();
            this.$message({
              message: type == "1" ? "保存成功" : "提交确认成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        });
      } else {
        this.$message({
          message: "不参与原因不能为空！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },

    // 生效的前置校验，提示黑名单信息等
    refCheckEffect() {
      this.dealSupComCheckEffect();
    },
    dealSupComCheckEffect() {
      let flag = true;
      let num = 0;
      this.tableData.forEach(item => {
        if (item.isJoinGuidePrice == "1") {
          // 参与
          item.notJoinReason = "";
          item.notJoinReasonStr = "";
        } else {
          if (!item.notJoinReason) {
            flag = false;
          } else {
            num++;
          }
        }
      });
      if (flag && num !== this.tableData.length) {
        let packIdArr = [];
        this.tableData.forEach(item => {
          if (packIdArr.every(packItem => packItem.packId !== item.packId)) {
            packIdArr.push(item);
          }
        });
        let sscPackSupComCheckBOS = [];
        packIdArr.forEach(item => {
          let sscPackSupComCheckBO = {};
          let sscEvaExtractPackBOS = [];
          sscPackSupComCheckBO.packId = item.packId;
          sscPackSupComCheckBO.packName = item.packName;
          this.tableData.forEach(tableItem => {
            if (item.packId === tableItem.packId) {
              let sscSupComPriceBO = {};
              sscSupComPriceBO.supCode = tableItem.supCode;
              sscSupComPriceBO.supName = tableItem.supName;
              sscSupComPriceBO.priceAmount = tableItem.priceAmount;
              sscSupComPriceBO.taxAmount = tableItem.taxAmount;
              sscSupComPriceBO.noTaxPriceAmount = tableItem.noTaxPriceAmount;
              sscSupComPriceBO.isJoinGuidePrice = tableItem.isJoinGuidePrice;
              sscSupComPriceBO.isJoinGuidePriceStr =
                tableItem.isJoinGuidePrice === "1" ? "是" : "否";
              sscSupComPriceBO.notJoinReason = tableItem.notJoinReason;
              sscSupComPriceBO.round = tableItem.round;
              sscSupComPriceBO.disabled = tableItem.disabled;
              sscSupComPriceBO.supJoinId = tableItem.supJoinId;
              sscSupComPriceBO.supQuoteId = tableItem.supQuoteId;
              sscSupComPriceBO.reason = tableItem.reason;
              sscSupComPriceBO.supPackQuoteId = tableItem.supPackQuoteId;
              sscEvaExtractPackBOS.push(sscSupComPriceBO);
            }
          });
          sscPackSupComCheckBO.sscEvaExtractPackBOS = sscEvaExtractPackBOS;
          sscPackSupComCheckBOS.push(sscPackSupComCheckBO);
        });
        console.log("sscPackSupComCheckBOS", sscPackSupComCheckBOS);
        console.log("tableData", this.tableData);
        let _this = this;
        this.$confirm("评标基准价筛选生效后将无法修改，是否确定生效?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            dealEvaScreenPack({
              schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                .schemeId,
              sscEvaExtractPackResultBOS: sscPackSupComCheckBOS,
              evaPurStep: _this.$router.history.current.query.evaPurStep,
              purStep: _this.$router.history.current.query.menuKey,
              joinExpertId: JSON.parse(
                sessionStorage.getItem("expertSourceData")
              ).joinExpertId
            }).then(res => {
              if (res.data.code == "0") {
                this.$message({
                  message: "评标基准价筛选生效成功！",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                this.init();
              }
            });
          })
          .catch(() => {});
      } else {
        if (num === this.tableData.length) {
          this.$message({
            message: "至少要有一个分包商参与基准价计算！",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        } else {
          this.$message({
            message: "不参与原因不能为空！",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    },
    // 导出开始
    exportPdf() {
      this.exportData = [];
      if (this.tableData > 5000) {
        this.$message({
          message: "暂不支持5000行以上大批量数据导出",
          type: "warning",

          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.exportExcelData.forEach((item, index) => {
          item.sscEvaExtractPackBOS.forEach((aItem, aIndex) => {
            this.exportData.push({
              id: index + 1,
              packName: item.packName,
              supName: aItem.supName,
              // priceAmount: aItem.priceAmount,
              isJoinGuidePriceStr: aItem.isJoinGuidePriceStr,
              notJoinReason: aItem.notJoinReason
            });
          });
        });
        if (this.ExcelJS) {
          this.exportDefaultAll();
        } else {
          this.exportCompatibleAll();
        }
      }
    },
    async exportDefaultAll() {
      const wb = new this.ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("分包商初步评审结果");
      ws1.views = [{ state: "frozen", ySplit: 1 }];

      ws1.addRow(["分包商初步评审结果"]);
      ws1.addRow([this.content]);
      ws1.addRow([
        "序号",
        "包件名称",
        "分包商",
        "税额",
        "不含税金额",
        "含税金额",
        "是否参与基准价计算",
        "不参与原因"
      ]);
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "packName", width: 25 },
        { key: "supName", width: 25 },
        { key: "taxAmount", width: 25 },
        { key: "noTaxPriceAmount", width: 25 },
        { key: "priceAmount", width: 25 },
        { key: "isJoinGuidePriceStr", width: 50 },
        { key: "notJoinReason", width: 50 }
      ];
      let spanList = [];
      let start = 4;
      this.exportExcelData.forEach((item, index) => {
        let devspan = 0;
        devspan += item.sscEvaExtractPackBOS.length;
        item.sscEvaExtractPackBOS.forEach((aItem, aIndex) => {
          ws1.addRow([
            index + 1,
            item.packName,
            aItem.supName,
            aItem.priceAmount,
            aItem.isJoinGuidePriceStr,
            aItem.notJoinReason
          ]);
        });
        spanList.push({
          start: start,
          end: devspan + start - 1
        });
        start = devspan + start;
      });
      spanList.forEach(item => {
        ws1.mergeCells("A" + item.start + ":A" + item.end);
        ws1.mergeCells("B" + item.start + ":B" + item.end);
      });
      const buf = await wb.xlsx.writeBuffer();
      this.saveAs(new Blob([buf]), "分包商初步评审结果.xlsx");
    },
    exportCompatibleAll() {
      const header = [
        "序号",
        "包件名称",
        "分包商",
        "税额",
        "不含税金额",
        "含税金额",
        "是否参与基准价计算",
        "不参与原因"
      ];
      const filterVal = [
        "id",
        "packName",
        "supName",
        "taxAmount",
        "noTaxPriceAmount",
        "priceAmount",
        "isJoinGuidePriceStr",
        "notJoinReason"
      ];
      const excelArr = this.exportData;
      let count = 0;
      const list = [];
      excelArr.forEach((val, index) => {
        val.index = ++count;
        list.push(val);
      });
      const data = this.formatJson(filterVal, list);
      exportJsonToExcel({
        header,
        data,
        filename: "分包商初步评审结果"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-select .el-input.is-disabled .el-input__inner {
  padding: 0 20px 0 10px !important;
}
/deep/ .el-table .cell {
  width: auto !important;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
.p-r {
  position: relative;
}
.tipp {
  position: absolute;
  top: 26px;
  color: #d9001b;
  font-size: 14px;
  left: 140px;
}
</style>
